
export default {
    DESK:{},
    portalDesign:{},
    customPosition:{},
    hideEngine:{},
    defaultStyle:{
        '&$customPosition':{
            position: data => data.engine_position,
            top: (data) => {if (data.vertical_position === "top") return data.vertical_margin; return null},
            bottom: (data) => {if (data.vertical_position === "bottom") return data.vertical_margin; return null},
            right: (data) => {if (data.horizontal_position === "right") return data.horizontal_margin; return null},
            left: (data) => {if (data.horizontal_position === "left") return data.horizontal_margin; return null},
        },
        '&$hideEngine':{
            display: 'none'
        }
    },
    engineBtn:{
        position: data => data.btn_engine_position,
        top: (data) => {if (data.btn_vertical_position === "top") return data.btn_vertical_margin; return null},
        bottom: (data) => {if (data.btn_vertical_position === "bottom") return data.btn_vertical_margin; return null},
        right: (data) => {if (data.btn_horizontal_position === "right") return data.btn_horizontal_margin; return null},
        left: (data) => {if (data.btn_horizontal_position === "left") return data.btn_horizontal_margin; return null},

    },
    engineBtnOuterweb: data => ({
        zIndex: '400',
        position: data.btn_engine_position || 'fixed',
        top: (data.btn_vertical_position || 'bottom') === "top" ? (data.btn_vertical_margin || "0px") : null,
        bottom: (data.btn_vertical_position || 'bottom') === "bottom" ? (data.btn_vertical_margin || "20px") : null,
        right: (data.btn_horizontal_position || 'center') === "right" ? (data.btn_horizontal_margin || "0px") : null,
        left: (data.btn_horizontal_position || 'center') === "left" ? (data.btn_horizontal_margin || "0px") : (data.btn_horizontal_position || 'center') === "center" ? "50%" : null,
        transform: (data.btn_horizontal_position || 'center') === "center" ? "translateX(-50%)" : null,

        '& button': {
            color: data.btnTextColor,
            background: data.btnBgColor,
            padding: '1em 1.5em',
            letterSpacing: '1.5px',
            fontSize: '16px',
            fontWeight: '300',
            textTransform: 'uppercase',
            zIndex: '400',
            cursor: 'pointer',

            '&:hover': {
                color: data.btnTextColorHover,
                background: data.btnBgColorHover,
                transition: '.3s',
            }
        }
    }),
    portalDesignV2: data => ({
        [`@media (min-width: ${data.modalBreak}px)`]: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }
    }),
};